import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'parseNumber',
    standalone: false
})
// TODO: There is no template that actually uses this pipe. Pipes are normally used for
// "formatting", i.e. transforming raw data into display data in templates. It also does
// not make sense to have a pipe that performs "parsing". Consider converting this into
// a service instead.
export class ParseNumberPipe implements PipeTransform {

  transform(value: any): number {
    if (!value) return 0;

    if (typeof value === 'string') {
      const cleaned = value.replace(/,/g, '');
      return Number(cleaned) || 0;
    }

    return Number(value) || 0;
  }

}